<h2 class="mat-headline-6 mb-0">CargoSprint SprintPay login</h2>
<h4 class="mat-subtitle-1">Please enter your credentials</h4>

<app-login-form [sourceSignUp]="'alliance'" (eventOnChangeForgotPW)="forgotPW()" />
